module.exports = __webpack_public_path__ + "img/zzf_board_person1.d30f9228.png";